/** Abortable ICE gathering shared by browser and native WebRTC. */
export function waitForLiveVoiceIce(args: {
  complete: () => boolean;
  listen: (check: () => void) => () => void;
  signal: AbortSignal;
}): Promise<void> {
  if (args.signal.aborted)
    return Promise.reject(new Error('Live voice ICE gathering stopped'));
  if (args.complete()) return Promise.resolve();
  return new Promise((resolve, reject) => {
    let unlisten = () => {};
    const cleanup = () => {
      unlisten();
      args.signal.removeEventListener('abort', abort);
    };
    const check = () => {
      if (args.complete()) {
        cleanup();
        resolve();
      }
    };
    const abort = () => {
      cleanup();
      reject(new Error('Live voice ICE gathering stopped'));
    };
    unlisten = args.listen(check);
    args.signal.addEventListener('abort', abort, { once: true });
    if (args.signal.aborted) abort();
    else check();
  });
}
